import { render, staticRenderFns } from "./ProfileDetails.vue?vue&type=template&id=34575ba1&scoped=true"
import script from "./ProfileDetails.vue?vue&type=script&lang=js"
export * from "./ProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./ProfileDetails.vue?vue&type=style&index=0&id=34575ba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34575ba1",
  null
  
)

export default component.exports